// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","titleContainer":"Home_titleContainer__MIoww","homeTitle":"Home_homeTitle__tmNjr","homeButton":"Home_homeButton__cSZ9P"};